import { WooCommerceAccountBlock } from "@/integrations/wordpress/WooCommerceAccountBlock";
import AccountLabelGuard from "./AccountLabelGuard";
import AccountReturnGuard from "./AccountReturnGuard";
import "@/components/forms/light-form.css";
export default function Account() {
  return <section id="account-content" data-nav="light" aria-labelledby="account-heading" className="tt-light-form bg-[#f8fafb] text-[#0a1218]">
      <div className="border-b border-[#dbe6eb] px-4 pb-12 pt-16 sm:px-6 md:pb-16 md:pt-20 lg:px-8 lg:pb-20 lg:pt-24">
        <div className="mx-auto max-w-[1440px]">
          <div className="flex items-center gap-3">
            <span aria-hidden="true" className="h-px w-8 bg-[#159fdf]" />
            <span className="text-[10px] font-semibold uppercase tracking-[0.23em] text-[#1479a7]">
              Customer Account
            </span>
          </div>

          <div className="mt-6 grid gap-8 lg:grid-cols-[minmax(0,1fr)_360px] lg:items-end">
            <h1 id="account-heading" className="max-w-[900px] text-[clamp(3.25rem,7vw,7.4rem)] font-semibold leading-[0.88] tracking-[-0.065em] text-[#0a1218]">
              Your account.
            </h1>

            <p className="max-w-[360px] text-sm leading-6 text-[#56636a] sm:text-[15px]">
              Sign in to manage your account details, review orders, and keep
              your information up to date.
            </p>
          </div>
        </div>
      </div>

      <div className="px-4 py-12 pb-32 sm:px-6 sm:pb-24 md:py-16 md:pb-16 lg:px-8 lg:py-20 lg:pb-20">
        <div className="mx-auto max-w-[1440px]">
          <AccountLabelGuard />
          <AccountReturnGuard />
          <WooCommerceAccountBlock className="tek-account-block" />
        </div>
      </div>
    </section>;
}